module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-32.cd97ec1d.svg";